<script setup lang="ts">
import { onMounted } from 'vue'
import { useRoute, useRouter } from 'vue-router'

const route = useRoute()
const router = useRouter()

onMounted(() => {
  const candidate = route.query.out_trade_no ?? route.query.order_id ?? route.query.orderId
  const orderId = Array.isArray(candidate) ? String(candidate[0] ?? '') : String(candidate ?? '')
  if (/^[A-Za-z0-9_-]{1,64}$/.test(orderId)) {
    sessionStorage.setItem('zhiying-payment-return', JSON.stringify({
      orderId,
      receivedAt: Date.now()
    }))
  }
  void router.replace('/points')
})
</script>

<template>
  <main class="payment-return-page" role="status">
    正在返回知应并确认支付结果…
  </main>
</template>

<style scoped>
.payment-return-page {
  min-height: 60vh;
  display: grid;
  place-items: center;
  color: var(--muted);
  font-size: 14px;
}
</style>
